/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */

import React, { useState, useContext } from "react";
import { NumericFormat } from 'react-number-format';
import utils from "../../../utils";
import { isMobile } from "react-device-detect";
import QuestionFooter from "./QuestionFooter";
import {
  UmbracoContext,
  UmbracoStep,
} from "../../../components/Umbraco/UmbracoContext";
import { LabelTitle, LabelError, RowCenter, Slide ,Line} from 'meitav-uikit';

const { UmbracoUtills } = utils;
import { Parser as HtmlToReactParser } from 'html-to-react';
const htmlToReactParser = new HtmlToReactParser();

export default function Question1(props) {
  const { stepActive, anserOld, resourceIcon, questions, setNextDisabled  } = props;
  const htmlToReactParser = new HtmlToReactParser();
  const [depositSum, setDepositSum] = useState(25000);

  const resource = UmbracoStep(
    useContext(UmbracoContext).resource,
    "Question1"
  );
  const Validations = UmbracoStep(
    useContext(UmbracoContext).resource,
    "Validations"
  );
  const [depositSumError, setDepositSumError] = useState(false);
  const [depositSum25000Error, setDepositSum25000Error] = useState(false);
  const [depositSum1000000Error, setDepositSum1000000Error] = useState(false);

  const [firstLoad, setFirstLoad] = useState("");

  const changeDepositSum = (event) => {
    setDepositSumError(false);
    setDepositSum(event);
    setNextDisabled(false);

    props.changeAnswerFunc(stepActive, event);
  };
  const handleBlur = (event) => {
    onChange(event.target.value);
    setDepositSumError(false);
    setDepositSum25000Error(false);
    setDepositSum1000000Error(false);

    if (event.target.value) {
      const val = parseInt(
        event.target.value.replace(/,/g, "").replace("₪", "")
      );

      if (val < 25000 || val > 1000000) {
        setDepositSumError(true);
        setDepositSum(25000);
        if (val < 25000) {
          setDepositSum25000Error(true);
        }
        if (val > 1000000) {
          setDepositSum1000000Error(true);
        }
      } else {
        setDepositSum(val);
      }
      setNextDisabled(false);

      props.changeAnswerFunc(stepActive, val);
    }
  };

  if (firstLoad != stepActive) {
    setDepositSum(parseInt(anserOld));
    setFirstLoad(stepActive);
    setNextDisabled(false);

    if (anserOld != 0) props.changeAnswerFunc(stepActive, parseInt(anserOld));
  }
  const onChange = (event) => {
    const action_name1 = `סכום ראשוני להפקדה - ${event} `;
    window.dataLayer.push({
      event: "PM - needs",
      eventInfo: {
        action_screen: window.location.pathname,
        process_level: "סכום ההשקעה הראשוני",
        action_name: action_name1,
      },
    });
  };
  return (
    <>
      <LabelTitle type="title">{htmlToReactParser.parse(UmbracoUtills.getValueByKey(resource, "title"))}   </LabelTitle>
      <RowCenter>   
        <NumericFormat
          id="Question1"
          className="inputNumber "
          value={depositSum}
          thousandSeparator
          prefix="₪"
          pattern="[0-9]*"
          onBlur={handleBlur}
          aria-describedby="depositSumErrorMax depositSumErrorMin"
          aria-required="true"
        />

        {depositSumError ? (
            <Line>
          <LabelError
          >
            {depositSum25000Error
              ? htmlToReactParser.parse(
                UmbracoUtills.getValueByKey(Validations, "depositSum25000Error")
              )
              : htmlToReactParser.parse(
                UmbracoUtills.getValueByKey(
                  Validations,
                  "depositSum1000000Error"
                )
              )}
          </LabelError></Line>
        ) : null}
      </RowCenter>
      <Slide
        value={depositSum}
        step={10}
        shekelIcon={true}
        minValue={25000}
        maxValue={1000000}
        onChange={changeDepositSum}
        onBlur={() => onChange(depositSum)}
      />
      <QuestionFooter
        icon={UmbracoUtills.getValueByKey(resourceIcon, "icon")}
        iconUp={UmbracoUtills.getValueByKey(resourceIcon, "iconUp")}
        iconDown={UmbracoUtills.getValueByKey(resourceIcon, "iconDown")}
        whyImportant={UmbracoUtills.getValueByKey(resource, "whyImportant")}
        tooltip={UmbracoUtills.getValueByKey(resource, "tooltip")}
        text={UmbracoUtills.getValueByKey(resource, "text")}
      />
    </>
  );
}
